/**
 * Central AdSense config. Single source for the publisher id, the per-placement slot ids
 * (created in the AdSense console — WEB-73), and the feed insertion cadence.
 *
 * AdSense is a third-party tracker with no cookieless mode, so it does not run before the user's
 * choice (APP-1182).
 */

export const ADSENSE_CLIENT = "ca-pub-1006380973567470";

export const AD_SLOTS = {
  // Deal feed: responsive display unit occupying a single grid cell like a deal card. A display
  // unit has no min width, so it fits the ~195px desktop cell and the ~160px mobile cell — a fluid
  // in-feed unit can't (it needs ≥250px and threw TagError in these cells, WEB-71).
  dealFeed: {
    slot: "4312720415", // web_deal_feed_display (display, responsive)
    format: "auto",
    fullWidthResponsive: true,
  },
} as const;

// Code-side kill switch. Flip to false to fully stop serving (no loader, no <ins>, no events) — this
// is the only kill switch; an AdSense manual unit can't be stopped from the console.
export const ADS_ENABLED = false;

/**
 * Insert one ad after every N feed items. Split by breakpoint because the same item-interval reads
 * denser on a wide multi-column grid than on the 2-col mobile grid. Measured against 10/20 on ~7.5k
 * feed users per group: +35% impressions per user, no measurable drop in deal clicks, detail views
 * or return visits.
 */
export const DEAL_FEED_AD_INTERVAL = { mobile: 6, desktop: 12 };
